import { render, staticRenderFns } from "./BuilderHeaderPublishButton.vue?vue&type=template&id=de5fbe48&scoped=true&"
import script from "./BuilderHeaderPublishButton.vue?vue&type=script&lang=js&"
export * from "./BuilderHeaderPublishButton.vue?vue&type=script&lang=js&"
import style0 from "./BuilderHeaderPublishButton.vue?vue&type=style&index=0&id=de5fbe48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de5fbe48",
  null
  
)

export default component.exports